import {Assistant} from "./assistant";
import {functionCalls} from "../definitions/functionCalls";


export class GeminiAssistant extends Assistant {
    constructor() {
        super();

    }

    override getApiUrl(): string {
        return 'https://localhost:7180/gemini/chat';
    }

    override getFunctionCalls(): any {
        debugger;
        return functionCalls.map(func => {
            const { name, description, parameters } = func.function;
            return {
                name,
                description,
                parameters: parameters ? {
                    type: "object",
                    properties: parameters.properties || {},
                    required: parameters.required || []
                } : undefined
            };
        });
    }


    override addSystemMessage(message) {
        debugger;
        const item = {
            "role": "user",  //??? "system not working"
            "parts": [
                    { "text": message }
                ]
            };
        this.messages.push(item);
    }

    override addUserMessage(message) {
        debugger
        const item = {
            "role": "user",
            "parts": [
                { "text": message }
            ]
        };
        this.messages.push(item);

    }

    override addToolCall(functionId, functionName, functionArgs, functionResult) {
        debugger;
        this.requiredAnotherChat = true;

        const message = functionName + '() results: ' + functionResult;
        const item = {
            "role": "user",
            "parts": [
                { "text": message }
            ]
        };
        this.toolResults.push(item);

    }

    override getFunctionList(result) {
        return result.candidates.flatMap(candidate => candidate.content.parts);
    }


    override getPrompt() {
        this.requiredAnotherChat = false;

        let messages = Array.from(this.messages);
        if (this.toolResults.length > 0) {
            messages = messages.concat(this.toolResults);
        }

        return {
            "tools" : [
                {
                    "functionDeclarations": this.getFunctionCalls()
                }
            ],
            "contents": messages
        };
    }

}
